export const generateArrayByLength = sum => {
  let result = []
  for (var i = 0; i < sum; i++) {
    result.push(i)
  }
  return result
}

export const getSearchQueryOnLoad = (searchTerm, searchQuery) => {
  if (!searchTerm?.length && searchQuery?.length > 0) {
    const searchParams = new URLSearchParams(location.search)
    const queryTerm = searchParams.get('term')
    return queryTerm ? decodeURIComponent(queryTerm) : ''
  } else {
    return searchTerm
  }
}
